import React from "react"
import moment from "moment";

class ListStatics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status : ""
        }
    }
    componentWillReceiveProps(props){
        const status = props.status;
        this.setState({
            status : status
        })
    }
    render = () => (
        <table className={"list-reports " + this.state.status}>
            <tr>
                <td>
                    <span className="title-report">REPORTE E-COMMERCE GARZA BLANCA WINTER SALE</span>
                    <div>
                        <span>Fecha de Creación: 14-May-2018</span>
                        <span>Intervalo de análisis: 14-May-2018 al 31-May-2018</span>
                    </div>
                </td>
                <td>
                    <span className=""><a className="share"></a>{10}</span>
                    <a className="edit"></a>
                    <a className="remove"></a>
                </td>
            </tr>
            <tr>
                <td>
                    <span className="title-report">REPORTE E-COMMERCE GARZA BLANCA WINTER SALE</span>
                    <div>
                        <span>Fecha de Creación: 14-May-2018</span>
                        <span>Intervalo de análisis: 14-May-2018 al 31-May-2018</span>
                    </div>
                </td>
                <td>
                    <span className=""><a className="share"></a>{10}</span>
                    <a className="edit"></a>
                    <a className="remove"></a>
                </td>
            </tr>
            <tr>
                <td>
                    <span className="title-report">REPORTE E-COMMERCE GARZA BLANCA WINTER SALE</span>
                    <div>
                        <span>Fecha de Creación: 14-May-2018</span>
                        <span>Intervalo de análisis: 14-May-2018 al 31-May-2018</span>
                    </div>
                </td>
                <td>
                    <span className=""><a className="share"></a>{10}</span>
                    <a className="edit"></a>
                    <a className="remove"></a>
                </td>
            </tr>
        </table>
    )
}

export default ListStatics;


// WEBPACK FOOTER //
// ./src/Frontend/reports/ListStatics.js